// extracted by mini-css-extract-plugin
export default {"dataFieldsDialog":"tOw_4"};